import {DepartmentsClient} from '../../client/departments-client'
import {Sync} from '../../client/sync'
import {Lang} from 'yougile-lang'
import {SandboxTree, User} from 'yougile-model'
import {saveAsXlsx} from 'yougile-util'
import {UserUtils} from '@extensions/user-utils'
import {Accounts} from '@client/accounts'
import {CompanyPreferencesClient} from '@client/company-preferences-client'

const getEmail = (box: SandboxTree, user: User): string => {
  const canSee = CompanyPreferencesClient.isAllowedForCurrentUser(
    box.companyId,
    'seeEmails'
  )

  const email = user?.email ?? ''

  return canSee ? email : ''
}

export const downloadRolesInDepartment = (): void => {
  const box = Sync.getCurrentSandbox()
  const msg = Lang.msg.users
  const data: string[][] = [
    [
      msg.headerDepartment,
      msg.headerName,
      msg.headerEmail,
      msg.headerDepartmentRole
    ]
  ]

  const all = UserUtils.sortByName(box.getAllUsers(false))

  all.forEach(u => {
    const deps = DepartmentsClient.listForUser(box, u.id)
    deps.forEach(dep => {
      const role = dep.managers.includes(u.id)
        ? msg.departmentManager
        : msg.departmentUser

      data.push([dep.title, Accounts.getName(u.id), getEmail(box, u), role])
    })
  })

  saveAsXlsx(`roles-in-departments.xlsx`, data, {columnsWidthToItems: true})
}
